import { styled } from '@mui/material/styles'
import palette from '../theme/palette'
import { getFontSize, getFontWeight, getLineHeight } from '../theme/comprehensive-theme'
import Typography from '@mui/material/Typography'

interface Props {
  color?: string
  weight?: number
  fontSize?: string
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const Text = styled(Typography)<Props>(({
  color = palette.black.main,
  weight = getFontWeight('semiBold'),
  fontSize = getFontSize('sm'),
}) => {
  return {
    fontSize,
    color,
    fontWeight: weight,
    lineHeight: getLineHeight('normal'),
    margin: 0,
  }
})
